export function normalizeBarcode(raw: string): string | null {
    const clean = raw.replace(/\D/g, "");

    if (clean.length === 14) return clean;
    if (clean.length >= 8 && clean.length <= 13)
        return clean.padStart(13, "0");

    return null;
}


export const waitVisible = (id: string, tries = 15, step = 100): Promise<void> =>
    new Promise((res, rej) => {
      const el = document.getElementById(id);
      if (el && el.offsetWidth > 10 && el.offsetHeight > 10) return res();
      if (tries === 0) return rej(new Error("region-not-ready"));
      setTimeout(() => waitVisible(id, tries - 1, step).then(res).catch(rej), step);
    });
  